export default "__VITE_ASSET__9fe98821__"